module.exports = __webpack_public_path__ + "media/packs/images/flags/FJ-b8eba6800048f7b6020e04d32e4fc2f5.svg";